<template>
  <!-- Error page-->
  <div class="misc-wrapper">

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <div class="logo-container">
          <b-link class="brand-logo">
            <!-- logo -->
            <span class="brand-logo">
            <b-img
              style="max-width: 126px"
              :src="appLogoImage"
              alt="logo"
            ></b-img>
          </span>
          </b-link>
        </div>
        <h2 class="mb-1">Страница не найдена 🕵🏻‍♀️</h2>
        <p class="mb-2">Ой! 😖 Запрашиваемый URL не найден!.</p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{path:'/'}"
        >Вернуться назад</b-button>

        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Error page"
        ></b-img>
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
import { BLink, BButton, BImg } from 'bootstrap-vue'
import store from '@/store/index'
import { getUserData } from '@/auth/utils'
import { getProgramVersionLogo } from '@/composables/currentUser'
import errorSrc from '@/assets/images/pages/error.svg'
import errorDark from '@/assets/images/pages/error-dark.svg'
import { computed } from 'vue'

export default {
  components: { BLink, BButton, BImg },
  setup() {
    let appLogoImage = getProgramVersionLogo()
    const user = getUserData()
    const imgUrl = computed(() => store.state.appConfig.layout.skin === 'dark' ? errorDark : errorSrc)
    if (user && user.logo_svg && user.logo_svg.url) {
      appLogoImage = user.logo_svg.url
    }

    return {
      appLogoImage,
      imgUrl,
    }
  },
}
</script>

<style lang='scss'>
@import '@/core/scss/vue/pages/page-misc.scss';

.misc-wrapper {
  .misc-inner {
    .logo-container {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px 0;
      .brand-logo {
        display: contents;
      }
    }
  }
}
</style>
